/* stabc.js — nav panel, carousel arrows and scroll reveals, ported from the approved preview theme (sx- prefixed). */
(function () {
  'use strict';
  window.sxOpenNav = function () {
    var p = document.getElementById('sxMobilePanel'), s = document.getElementById('sxScrim');
    if (p) { p.classList.add('sx-open'); p.setAttribute('aria-hidden', 'false'); }
    if (s) s.classList.add('sx-show');
  };
  window.sxCloseNav = function () {
    var p = document.getElementById('sxMobilePanel'), s = document.getElementById('sxScrim');
    if (p) { p.classList.remove('sx-open'); p.setAttribute('aria-hidden', 'true'); }
    if (s) s.classList.remove('sx-show');
  };
  window.sxScrollTrack = function (dir, id) {
    var t = document.getElementById(id);
    if (!t) return;
    var card = t.querySelector('.sx-card'), step = card ? card.offsetWidth + 22 : 322;
    t.scrollBy({ left: dir * step, behavior: 'smooth' });
  };
  function initReveals() {
    var reveals = document.querySelectorAll('.sx-reveal');
    if (!('IntersectionObserver' in window)) { reveals.forEach(function (el) { el.classList.add('sx-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('sx-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
    setTimeout(function () { reveals.forEach(function (el) { el.classList.add('sx-in'); }); }, 2500);
  }
  /* Sticky header: measure the announcement bar so it scrolls away, expose the
     header height for anchor offsets, and flag the scrolled (condensed) state. */
  function initStickyHeader() {
    var header = document.querySelector('[data-sx-header]');
    if (!header) return;
    var wrap = header.closest('.sx-header-section') || header.parentElement;
    var announce = wrap.querySelector('.sx-announce');
    var root = document.documentElement;
    var sticky = header.hasAttribute('data-sticky');
    if (header.hasAttribute('data-condense')) wrap.classList.add('sx-condense');
    function measure() {
      var a = announce ? announce.offsetHeight : 0;
      wrap.style.setProperty('--sx-announce-h', a + 'px');
      root.style.setProperty('--sx-header-h', sticky ? header.offsetHeight + 'px' : '0px');
    }
    var scrolled = false;
    function onScroll() {
      /* hysteresis (on at +40px, off below +10px) so the condense animation never flickers */
      var a = announce ? announce.offsetHeight : 0, y = window.scrollY;
      var next = sticky && (scrolled ? y > a + 10 : y > a + 40);
      if (next !== scrolled) { scrolled = next; wrap.classList.toggle('sx-scrolled', scrolled); }
    }
    measure();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(header);
  }
  /* Hero slideshow: fade between slides; dots, pause/play, swipe. Autoplay stops on
     hover/focus, hidden tab, reduced-motion preference, or when the visitor pauses. */
  function initSlideshows(scope) {
    (scope || document).querySelectorAll('[data-sx-slideshow]').forEach(function (root) {
      if (root._sx) return;
      var slides = root.querySelectorAll('[data-sx-slide]');
      var dots = root.querySelectorAll('[data-sx-dot]');
      var pauseBtn = root.querySelector('[data-sx-pause]');
      if (slides.length < 2) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
      var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduce;
      var current = 0, timer = null, userPaused = false, hovering = false;
      function go(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          var on = n === current;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on) { var img = s.querySelector('img[loading="lazy"]'); if (img) img.loading = 'eager'; }
        });
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === current);
          d.setAttribute('aria-selected', n === current ? 'true' : 'false');
        });
        var next = slides[(current + 1) % slides.length].querySelector('img[loading="lazy"]');
        if (next) next.loading = 'eager';
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        stop();
        if (autoplay && !userPaused && !hovering && !document.hidden) timer = setInterval(function () { go(current + 1); }, interval);
      }
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-sx-dot'), 10)); start(); });
      });
      if (pauseBtn) {
        if (!autoplay) pauseBtn.hidden = true;
        pauseBtn.addEventListener('click', function () {
          userPaused = !userPaused;
          pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
          pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
          start();
        });
      }
      root.addEventListener('mouseenter', function () { hovering = true; stop(); });
      root.addEventListener('mouseleave', function () { hovering = false; start(); });
      root.addEventListener('focusin', function () { hovering = true; stop(); });
      root.addEventListener('focusout', function () { hovering = false; start(); });
      document.addEventListener('visibilitychange', start);
      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 45) { go(current + (dx < 0 ? 1 : -1)); start(); }
      }, { passive: true });
      /* Theme editor: show the slide being edited */
      root.addEventListener('shopify:block:select', function (e) {
        var el = e.target.closest ? e.target.closest('[data-sx-slide]') : null;
        if (el) { hovering = true; stop(); go(parseInt(el.getAttribute('data-index'), 10)); }
      });
      root.addEventListener('shopify:block:deselect', function () { hovering = false; start(); });
      root._sx = { go: go, start: start, stop: stop };
      start();
    });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') window.sxCloseNav(); });
  document.addEventListener('DOMContentLoaded', function () { initReveals(); initStickyHeader(); initSlideshows(); });
  document.addEventListener('shopify:section:load', function (e) { initSlideshows(e.target); });
  document.addEventListener('shopify:section:load', initStickyHeader);
  document.addEventListener('shopify:section:load', initReveals);
})();
